import React from "react";
import PolicyPage from "./PolicyPage";

const TOC = [
  { id: "mission",       label: "Mission" },
  { id: "product",       label: "The product" },
  { id: "team",          label: "Team" },
  { id: "principles",    label: "Principles" },
  { id: "contact",       label: "Contact" },
];

export default function About() {
  return (
    <PolicyPage
      testId="page-about"
      path="/about"
      title="About TalesTalesTales | AI Novel"
      description="TalesTalesTales is an interactive AI Novel with a Memory Codex, illustrated story worlds and switchable AI narrators. Learn about the mission and the product."
      eyebrow="About"
      h1="About TalesTalesTales"
      toc={TOC}
    >
      <section id="mission">
        <h2 className="font-display text-2xl text-amber-50 mt-2 mb-3">Mission</h2>
        <p>
          TalesTalesTales exists because interactive fiction should feel like a novel that answers
          back — illustrated, remembered, and shaped by the reader&rsquo;s choices. We build tools
          that let anyone become the main character in a story worth reading.
        </p>
      </section>

      <section id="product">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">The product</h2>
        <p>
          TalesTalesTales is an interactive AI Novel. Players create a character, enter an
          illustrated story world, and shape every chapter with their choices while an AI narrator
          writes each scene in literary prose. The Memory Codex tracks important characters, events,
          inventory changes and unresolved threads and feeds them back to the narrator, which improves
          continuity in long sagas, including across model swaps.
        </p>
        <p>
          The RPG layer (occasional dice rolls, skills, equipment, inventory, objectives) is light and
          opt-in — flavour and structure, not a deep tabletop simulation. Standard sagas are safe by
          default; a Mature Realms add-on unlocks adult storytelling for verified 18+ subscribers.
        </p>
      </section>

      <section id="team">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Team</h2>
        <p>
          TalesTalesTales is built by a small independent team of writers and engineers. We are not
          affiliated with any of the third-party model providers whose narrators we integrate
          (Anthropic, OpenAI, Google, and OpenRouter), nor with any other interactive-fiction
          product mentioned on this site.
        </p>
      </section>

      <section id="principles">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Principles</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Continuity first.</strong> A book that forgets you is not a book.</li>
          <li><strong>Author&rsquo;s voice, not chat.</strong> The narrator writes in prose, not shorthand.</li>
          <li><strong>Safety by default.</strong> Mature content is opt-in, age-verified, and never appears in standard sagas.</li>
          <li><strong>Clear pricing.</strong> Every account gets 10 free turns per day; paid tiers add turns and premium narrators.</li>
        </ul>
      </section>

      <section id="contact">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Contact</h2>
        <p>
          Reach us via the <a href="/support" className="underline hover:text-amber-100">support page</a>{" "}
          or by email at <a href="mailto:hello@talestalestales.com" className="underline hover:text-amber-100">hello@talestalestales.com</a>.
        </p>
      </section>
    </PolicyPage>
  );
}
